const CLIENT_HINTS_HIGH_ENTROPY_KEYS = [
  'architecture',
  'bitness',
  'brands',
  'mobile',
  'model',
  'platform',
  'platformVersion',
  'uaFullVersion',
  'fullVersionList',
  'wow64',
] as const;

type ClientHintsHighEntropyKey = (typeof CLIENT_HINTS_HIGH_ENTROPY_KEYS)[number];

interface NavigatorUserAgentData {
  getHighEntropyValues: (hints: ClientHintsHighEntropyKey[]) => Promise<Record<string, unknown>>;
}

let clientHintsPromise: Promise<string> | null = null;

/**
 * Collects browser client hints only when an Ayet data request needs them.
 * The result is cached because these device and browser values do not change during a page session.
 */
async function collectClientHints(): Promise<string> {
  if (typeof navigator === 'undefined') {
    return '';
  }

  const userAgentData = (navigator as Navigator & { userAgentData?: NavigatorUserAgentData }).userAgentData;
  if (!userAgentData) {
    return '';
  }

  try {
    const hints = await userAgentData.getHighEntropyValues([...CLIENT_HINTS_HIGH_ENTROPY_KEYS]);
    return JSON.stringify(hints);
  } catch {
    return '';
  }
}

export async function getAyetClientHintsHeaders(): Promise<Record<string, string>> {
  clientHintsPromise = clientHintsPromise ?? collectClientHints();
  const clientHints = await clientHintsPromise;

  return clientHints ? { 'x-client-hints': clientHints } : {};
}
